module.exports = __webpack_public_path__ + "media/images/subject_img/FILM STUDIES-MEDIA STUDIES-CREATIVE ARTS-00e238ff909e4e02a533aa5806c3d483.jpg";